import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { colorType, defaultTheme, withTheme } from 'common/styling/theme';
import { staticStyles } from './style';

const SliderField = ({ input, minValue, maxValue, step, unit, disabled, primaryColor }) => {
  const value = Number(input.value || minValue);
  const sliderValue = Math.min(maxValue, Math.max(minValue, value));

  const progress = ((sliderValue - minValue) / (maxValue - minValue)) * 100;
  const valuePosition = Math.min(96, Math.max(4, progress));

  const inputStyle = {
    background: `linear-gradient(to right, ${primaryColor.hex} 0%, ${primaryColor.hex} ${progress}%, rgba(${primaryColor.rgb}, 0.2) ${progress}%, rgba(${primaryColor.rgb}, 0.2) 100%)`,
  };

  const normalizeValue = value => {
    const steppedValue = Math.round(Number(value) / step) * step;

    return Math.min(maxValue, Math.max(minValue, steppedValue));
  };

  const handleChange = event => input.onChange(normalizeValue(event.target.value));
  const handleBlur = event => input.onBlur(normalizeValue(event.target.value));

  return (
    <div className="SliderField">
      <div className="SliderField__limits">
        <span>
          <FormattedMessage id="justMin" />. {minValue}
        </span>
        <span>
          <FormattedMessage id="justMax" />. {maxValue}
        </span>
      </div>
      <div className="SliderField__control">
        <input
          aria-label={input.name}
          className="SliderField__input"
          type="range"
          min={minValue}
          max={maxValue}
          step="any"
          value={sliderValue}
          style={inputStyle}
          disabled={disabled}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={input.onFocus}
        />
        <span className="SliderField__value" style={{ background: primaryColor.hex, left: `${valuePosition}%` }}>
          {value}
          {unit}
        </span>
      </div>
      <style jsx global>
        {staticStyles}
      </style>
    </div>
  );
};

SliderField.propTypes = {
  input: PropTypes.object.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  primaryColor: colorType,
  unit: PropTypes.string,
  disabled: PropTypes.bool,
};

SliderField.defaultProps = {
  primaryColor: defaultTheme.colors.primary,
  unit: '',
  disabled: false,
};

export default withTheme(({ colors: { primary } }) => ({ primaryColor: primary }))(SliderField);
export { SliderField };
